// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__+iY7c","lastLink":"HeadPage_lastLink__UxJwz"};